import { render } from "./slide23.vue?vue&type=template&id=7f001f94&scoped=true"
import script from "./slide23.vue?vue&type=script&lang=js"
export * from "./slide23.vue?vue&type=script&lang=js"

import "./slide23.vue?vue&type=style&index=0&id=7f001f94&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f001f94"]])

export default __exports__